import { module } from 'modujs';
const Scrollbar = require("smooth-scrollbar");
import Emitter from 'tiny-emitter/instance';


export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: { 'dropdown-item': 'onDropDownItem', },
            input: { 'input-filter': 'onInput' }
        };
        this.isOpen = false;
        this.button = this.$( 'button' )[0];
        this.el.addEventListener( 'click', e => e.stopPropagation() );
        this.button.addEventListener( 'click', e => {
            Emitter.emit('click-outside', this.el );
            this.toggle();
        } );
        Emitter.on('click-outside', el => this.isOpen && this.el !== el && this.toggle() );
        this.dropDownItemPreview = this.$( 'dropdown-item-preview' );
        this.isMultiple = this.el.dataset.multiple === 'true';
        this.dropDownItems = [... this.$( 'dropdown-item' ) ];

        this.el.classList.toggle( 'not-empty', this.el.querySelector( '[data-dropdown="dropdown-item"].active' ) );
    }
    toggle(){
        this.isOpen = ! this.isOpen;
        this.el.classList.toggle( 'active' );
    }

    onInput( e ){
        this.dropDownItems.forEach( item => item.classList.toggle( 'hidden', ! item.dataset.value.toLowerCase().includes( e.target.value.toLowerCase() )) );

    }

    onDropDownItem( e ){
        let target = e.currentTarget;
        if( ! this.isMultiple ){
            let active = this.el.querySelector( '[data-dropdown="dropdown-item"].active' );
            if( active ) active.classList.remove( 'active' );
            target.classList.add( 'active' );
            let targetText = target.querySelector( '[data-dropdown-item-text]' );
            if( this.dropDownItemPreview[0] && targetText){

                this.dropDownItemPreview[0].textContent = targetText.textContent;
            }

        } else {
            target.classList.toggle( 'active' );
        }
        this.el.classList.toggle( 'not-empty', this.el.querySelector( '[data-dropdown="dropdown-item"].active' ) );
        this.toggle();
        Emitter.emit( 'dropdown-click' );

    }
}
